import { useQuery } from '@tanstack/react-query';
import { Loader, Modal } from '@lms/ui';
import { SafeHtml } from '@/components/SafeHtml';
import { api } from '@/lib/api';
import type { LegalPolicyPublicDetail } from './types';

interface LegalPolicyModalProps {
  open: boolean;
  slug: string;
  title?: string;
  onClose: () => void;
}

export function LegalPolicyModal({ open, slug, title, onClose }: LegalPolicyModalProps) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['legal-policies', 'by-slug', slug],
    queryFn: () => api<LegalPolicyPublicDetail>(`/legal/policies/by-slug/${slug}`),
    enabled: open && Boolean(slug),
  });

  return (
    <Modal open={open} onClose={onClose} title={title ?? data?.title ?? 'Política legal'} size="lg">
      {isLoading ? (
        <Loader label="Cargando política…" />
      ) : error ? (
        <p className="text-red-700">No se pudo cargar la política.</p>
      ) : data ? (
        <div className="legal-policy-modal-body">
          <SafeHtml html={data.bodyHtml} className="prose max-w-none legal-policy-public-content" />
          {data.publishedAt ? (
            <p className="mt-6 text-sm text-on-surface-variant">
              Versión {data.version} · Publicada {new Date(data.publishedAt).toLocaleDateString('es-ES')}
            </p>
          ) : null}
        </div>
      ) : null}
    </Modal>
  );
}
